import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    '& > *': {
      padding: theme.spacing(1)
    },
    flexGrow: 1,
    width: '100%'
  },
  textField: {
    width: '100%'
  },
  button: {
    width: '100%'
  }
}));
